import React, { useState, useRef, useEffect } from "react";
import {
  Bell,
  User,
  LogOut,
  KeyRound,
  ChevronDown,
  Menu,
  Plus,
  Search,
  Filter,
  Edit3,
  Trash2,
  AlertCircle,
  CheckCircle2,
  Timer,
  FileText,
  Receipt,
  X,
  ChevronRight,
  ChevronLeft,
  Eye,
  SlidersHorizontal,
  FileSpreadsheet
} from "lucide-react";
import Sidebar from "../components/layout/Sidebar";
import Header from "../components/layout/Header";
import StatCard from "../components/ui/StatCard";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { toast } from "react-hot-toast";

const SupportdSec1 = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(window.innerWidth > 1024);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [issues, setIssues] = useState([]); // أضفنا الـ state الخاص بالمشكلات
  const navigate = useNavigate();
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [isViewOpen, setIsViewOpen] = useState(false);

  // 1. دالة جلب البيانات (يجب استدعاؤها)
  // const fetchIssues = async () => {
  //   try {
  //     setLoading(true);
  //     const token = localStorage.getItem("token"); // يجب أن يكون الاسم "token"

  //     // إضافة التوكن في الهيدر بشكل صحيح
  //     const response = await axios.get("/api/issues", {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     console.log("البيانات المستلمة:", response.data);
  //     setIssues(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.error("خطأ في الجلب:", error.response || error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   fetchIssues();
  // }, []);



  // لوحة الفلاتر المتقدمة المطوية
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const handleView = (issue) => {
    setSelectedIssue(issue);
    setIsViewOpen(true);
  };

  useEffect(() => {
    document.title = "إدارة دعم التعاملات الضريبية";
  }, []);

  const [settings, setSettings] = useState({
    docTypes: [],
    categories: [],
    channels: [],
    mechanisms: [],
  });

  const [searchTerm, setSearchTerm] = useState("");

  const [filters, setFilters] = useState({
    documentType: "",
    category: "",
    channel: "",
    mechanism: "",
    hasObjection: "",
    receivedStartDate: "",
    receivedEndDate: "",
    entryStartDate: "",
    entryEndDate: "",
  });

  const [newIssue, setNewIssue] = useState({
    id: null,
    documentTypeId: "",
    categoryId: "",
    channelId: "",
    mechanismId: "",
    receivedDate: "",
    problem: "",
    solution: "",
    objection: "",
    objectionSolution: "",
    notes: "",
  });

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    const fetchInitialData = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        console.warn("لا يوجد توكن، يتم التحويل لصفحة الدخول");
        navigate("/login");
        return;
      }

      const authHeaders = {
        headers: { Authorization: `Bearer ${token}` },
      };

      try {
        setLoading(true);
        const [settingsRes, issuesRes] = await Promise.all([
          axios.get("/api/issue-settings", authHeaders),
          axios.get("/api/issues", authHeaders),
        ]);
        const data = settingsRes.data;

        setSettings({
          docTypes: data.documentTypes || [],
          categories: data.issueCategories || [],
          channels: data.issueChannels || [],
          mechanisms: data.solutionMechanisms || [],
        });

        // تحويل الـ flat fields القادمة من sp_GetAllIssues لـ nested objects
        // SP بترجع: docTypeName, categoryName, channelName, mechanismName
        // React بيدور على: documentType.name, category.name, channel.name, mechanism.name
        const mappedIssues = (issuesRes.data || []).map((issue) => ({
          ...issue,
          documentType: { name: issue.docTypeName || "" },
          category:     { name: issue.categoryName || "" },
          channel:      { name: issue.channelName || "" },
          mechanism:    { name: issue.mechanismName || "" },
        }));
        setIssues(mappedIssues);
      } catch (err) {
        console.error("Error fetching data:", err);
        if (err.response?.status === 401) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } finally {
        setLoading(false);
      }
    };
    fetchInitialData();
  }, []);

  // الحسابات والفلترة الدقيقة مع تصفير توقيت حقل الـ createdAt ليعمل بنجاح
  const filteredIssues = issues.filter((issue) => {
    const matchesSearch =
      issue.id.toString().includes(searchTerm) ||
      issue.problem.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (issue.objection &&
        issue.objection.toLowerCase().includes(searchTerm.toLowerCase()));

    const matchesDocType =
      !filters.documentType ||
      issue.documentType?.name === filters.documentType;
    const matchesCategory =
      !filters.category || issue.category?.name === filters.category;
    const matchesChannel =
      !filters.channel || issue.channel?.name === filters.channel;
    const matchesMechanism =
      !filters.mechanism || issue.mechanism?.name === filters.mechanism;

    const matchesObjection =
      filters.hasObjection === "" ||
      (filters.hasObjection === "yes" &&
        issue.objection &&
        issue.objection.trim() !== "") ||
      (filters.hasObjection === "no" &&
        (!issue.objection || issue.objection.trim() === ""));

    // تصفير وقت تاريخ الورود للمقارنة العادلة باليوم
    const issueReceivedDate = issue.receivedDate
      ? new Date(issue.receivedDate)
      : null;
    if (issueReceivedDate) issueReceivedDate.setHours(0, 0, 0, 0);

    const recStart = filters.receivedStartDate
      ? new Date(filters.receivedStartDate)
      : null;
    if (recStart) recStart.setHours(0, 0, 0, 0);

    const recEnd = filters.receivedEndDate
      ? new Date(filters.receivedEndDate)
      : null;
    if (recEnd) recEnd.setHours(0, 0, 0, 0);

    const matchesRecStart =
      !recStart || (issueReceivedDate && issueReceivedDate >= recStart);
    const matchesRecEnd =
      !recEnd || (issueReceivedDate && issueReceivedDate <= recEnd);

    // تصفير وقت الـ Timestamp الخاص بـ createdAt المأخوذ من السيرفر
    const issueEntryDate = issue.createdAt ? new Date(issue.createdAt) : null;
    if (issueEntryDate) issueEntryDate.setHours(0, 0, 0, 0);

    const entStart = filters.entryStartDate
      ? new Date(filters.entryStartDate)
      : null;
    if (entStart) entStart.setHours(0, 0, 0, 0);

    const entEnd = filters.entryEndDate ? new Date(filters.entryEndDate) : null;
    if (entEnd) entEnd.setHours(0, 0, 0, 0);

    const matchesEntryStart =
      !entStart || (issueEntryDate && issueEntryDate >= entStart);
    const matchesEntryEnd =
      !entEnd || (issueEntryDate && issueEntryDate <= entEnd);

    return (
      matchesSearch &&
      matchesDocType &&
      matchesCategory &&
      matchesChannel &&
      matchesMechanism &&
      matchesObjection &&
      matchesRecStart &&
      matchesRecEnd &&
      matchesEntryStart &&
      matchesEntryEnd
    );
  });

  const downloadExcel = () => {
    // 1. تحديد مصدر البيانات الحالي المعروض
    const dataToExport = filteredIssues.length > 0 ? filteredIssues : issues;

    if (dataToExport.length === 0) {
      alert("لا توجد بيانات لتصديرها حالياً");
      return;
    }

    // 2. تحويل البيانات للأعمدة واستخدام الـ index ليكون هو الـ "م" المسلسل زي الـ UI
    const mappedData = dataToExport.map((item, index) => ({
      م: index + 1, // هنا السر! هيبدأ من 1، 2، 3.. بنفس ترتيب ظهورهم الحالي في الشاشة
      "نوع الوثيقة": item.documentType?.name || "---",
      "تصنيف المشكلة": item.category?.name || "---",
      "قناة المشكلة": item.channel?.name || "---",
      "تاريخ ورود المشكلة (إن وجد)": item.receivedDate
        ? new Date(item.receivedDate).toLocaleDateString("ar-EG")
        : "---",
      "تاريخ دخول المشكلة للمنظومة": item.createdAt
        ? new Date(item.createdAt).toLocaleDateString("ar-EG")
        : "---",
      "وصف المشكلة": item.problem,
      "حل المشكلة": item.solution || "قيد الانتظار",
      "الاعتراض على الحل": item.objection || "لا يوجد",
      "الحل بعد الاعتراض": item.objectionSolution || "---",
      الآلية: item.mechanism?.name || "---",
      ملاحظات: item.notes || "",
    }));

    // 3. بناء وتصدير ملف الإكسل
    const worksheet = XLSX.utils.json_to_sheet(mappedData);
    worksheet["!dir"] = "rtl";
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "المشكلات التقنية");
    XLSX.writeFile(
      workbook,
      `تقرير_المشكلات_${new Date().toLocaleDateString("ar-EG")}.xlsx`,
    );
  };

  const handleDelete = async (id) => {
    if (window.confirm("هل أنت متأكد من حذف هذه المشكلة؟")) {
      try {
        await axios.delete(`/api/issues/${id}`,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
        );
        setIssues(issues.filter((issue) => issue.id !== id));
        toast.success("تم الحذف بنجاح");
      } catch (error) {
        toast.error("فشل في الحذف");
      }
    }
  };

  const handleEdit = (issue) => {
    setNewIssue({
      id: issue.id,
      documentTypeId: issue.documentTypeId || "",
      categoryId: issue.categoryId || "",
      channelId: issue.channelId || "",
      mechanismId: issue.mechanismId || "",
      receivedDate: issue.receivedDate ? issue.receivedDate.split("T")[0] : "",
      problem: issue.problem || "",
      solution: issue.solution || "",
      objection: issue.objection || "",
      objectionSolution: issue.objectionSolution || "",
      notes: issue.notes || "",
    });
    setIsModalOpen(true);
  };

  const handleAddIssue = async (e) => {
    e.preventDefault();

    if (
      !newIssue.documentTypeId ||
      String(newIssue.documentTypeId).trim() === "" ||
      !newIssue.categoryId ||
      String(newIssue.categoryId).trim() === "" ||
      !newIssue.channelId ||
      String(newIssue.channelId).trim() === "" ||
      !newIssue.mechanismId ||
      String(newIssue.mechanismId).trim() === "" ||
      !newIssue.problem ||
      String(newIssue.problem).trim() === "" ||
      !newIssue.solution ||
      String(newIssue.solution).trim() === ""
    ) {
      toast.error(
        "عفواً! يجب ملء الحقول الإلزامية الستة أولاً (نوع الوثيقة، التصنيف، القناة، آلية الحل، وصف المشكلة، وحل المشكلة)",
      );
      return;
    }

    try {
      // 🚀 نأخذ الـ IDs من مصفوفة الصفحة الحالية المعروضة أمام المستخدم بالظبط
      const currentUiIds = currentItems.map((issue) => issue.id);

      const dataToSubmit = {
        ...newIssue,
        documentTypeId: parseInt(newIssue.documentTypeId),
        categoryId: parseInt(newIssue.categoryId),
        channelId: parseInt(newIssue.channelId),
        mechanismId: parseInt(newIssue.mechanismId),
        userId: user?.id,
        currentUiIds,
        // 🎯 نرسل مؤشر بداية الصفحة الحالية للباك إند ليطابق الحسبة
        indexOfFirstItem: indexOfFirstItem || 0,
      };

      if (newIssue.id) {
        await axios.put(
          `/api/issues/${newIssue.id}`,
          dataToSubmit,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
        );
        toast.success("تم التحديث بنجاح");
      } else {
        await axios.post("/api/issues", dataToSubmit,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
        );
        toast.success("تم الإضافة بنجاح");
      }

      setIsModalOpen(false);
      const issuesRes = await axios.get("/api/issues",
        { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } },
      );
      const mappedIssues = (issuesRes.data || []).map((issue) => ({
        ...issue,
        documentType: { name: issue.docTypeName || "" },
        category:     { name: issue.categoryName || "" },
        channel:      { name: issue.channelName || "" },
        mechanism:    { name: issue.mechanismName || "" },
      }));
      setIssues(mappedIssues);

      setNewIssue({
        id: null,
        documentTypeId: "",
        categoryId: "",
        channelId: "",
        mechanismId: "",
        receivedDate: "",
        problem: "",
        solution: "",
        objection: "",
        objectionSolution: "",
        notes: "",
      });
    } catch (error) {
      if (error.response && error.response.status === 409) {
        toast.error(error.response.data.message, {
          duration: 5000,
          style: { direction: "rtl" },
        });
      } else {
        toast.error("حدث خطأ غير متوقع أثناء الحفظ");
      }
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const sortedIssues = [...filteredIssues].sort((a, b) => a.id - b.id);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedIssues.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(sortedIssues.length / itemsPerPage);

  return (
    <div className="flex min-h-screen bg-[#F8F9FA] font-ibm" dir="rtl">
      <Sidebar
        isOpen={isSidebarOpen}
        toggleSidebar={() => setSidebarOpen(!isSidebarOpen)}
      />

      <div
        className={`flex-1 transition-all duration-300 p-4 md:p-8 overflow-y-auto ${isSidebarOpen ? "lg:mr-64" : "lg:mr-20"}`}
      >
        <Header
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          title="إدارة دعم التعاملات الضريبية"
        />

        {/* الترحيب وإضافة مشكلة جديدة */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-10 gap-6">
          <div>
            <h2 className="text-2xl md:text-3xl font-ibm font-extrabold text-[#546E7A]">
              أهلاً بك مجدداً، {user?.firstName} {user?.lastName}
            </h2>
            <p className="text-gray-400 font-ibm mt-1">
              يمكنك إضافة ومتابعة المشاكل التقنية وتفاصيل الاعتراضات وتواريخها
              بدقة.
            </p>
          </div>
          <button
            onClick={() => {
              setNewIssue({
                id: null,
                documentTypeId: "",
                categoryId: "",
                channelId: "",
                mechanismId: "",
                receivedDate: "",
                problem: "",
                solution: "",
                objection: "",
                objectionSolution: "",
                notes: "",
              });
              setIsModalOpen(true);
            }}
            className="bg-[#546E7A] hover:bg-[#263238] text-white px-8 py-3 rounded-2xl font-bold flex items-center gap-2 transition shadow-lg w-full md:w-auto justify-center"
          >
            <Plus size={20} /> إضافة مشكلة جديدة
          </button>
        </div>

        {/* الكروت الإحصائية */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
          <StatCard
            title="إجمالي المشاكل"
            value={issues.length}
            icon={<AlertCircle size={40} className="text-[#546E7A]" />}
            badge="الكل"
            badgeColor="text-blue-500 bg-blue-50"
          />
          <StatCard
            title="تم حلها"
            value={issues.filter((i) => i.mechanism?.name === "تم الحل").length}
            icon={<CheckCircle2 size={40} className="text-[#546E7A]" />}
            badge="مكتمل"
            badgeColor="text-green-500 bg-green-50"
          />
          <StatCard
            title="قيد المراجعة"
            value={
              issues.filter((i) => i.mechanism?.name === "قيد المراجعة").length
            }
            icon={<Timer size={40} className="text-[#546E7A]" />}
            badge="عاجل"
            badgeColor="text-orange-500 bg-orange-50"
          />
        </div>

        {/* القسم الرئيسي للجدول والبحث بتحديثات الـ UX الكاملة والـ Floating Labels */}
        <div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
          {/* شريط الإجراءات والبحث الفوقي المتوازن */}
          <div className="p-6 border-b border-gray-100 bg-gray-50/30 space-y-4">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
              {/* حقل البحث الذكي بـ Floating Label ناعم */}
              <div className="relative w-full sm:w-1/2 md:w-1/3 group">
                <Search
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-[#546E7A] transition-colors z-20"
                  size={18}
                />
                <input
                  type="text"
                  id="floatingSearch"
                  placeholder=" "
                  className="block w-full pr-11 pl-4 pt-6 pb-2 text-sm text-right bg-white border border-gray-200 rounded-2xl outline-none focus:border-[#546E7A] focus:ring-2 focus:ring-[#546E7A]/10 transition-all text-[#263238] font-medium peer"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <label
                  htmlFor="floatingSearch"
                  className="absolute text-sm text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-11 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-3 peer-focus:text-[#546E7A] pointer-events-none"
                >
                  البحث برقم المشكلة، الوصف أو الاعتراض...
                </label>
              </div>

              {/* أزرار التحكم الجانبية */}
              <div className="flex items-center gap-3 w-full sm:w-auto justify-end">
                <button
                  onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                  className={`flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-bold border transition-all ${showAdvancedFilters ? "bg-[#546E7A] text-white border-[#546E7A]" : "bg-white text-gray-600 border-gray-200 hover:bg-gray-50"}`}
                >
                  <SlidersHorizontal size={16} />
                  <span>تصفية متقدمة</span>
                </button>
                <button
                  onClick={downloadExcel}
                  className="flex items-center gap-2 px-5 py-3 bg-green-600 hover:bg-green-700 text-white rounded-xl text-sm font-bold transition shadow-md"
                >
                  <FileSpreadsheet size={16} />
                  <span>تصدير Excel</span>
                </button>
              </div>
            </div>

            {/* لوحة الفلاتر المتقدمة بـ Floating Labels ناعمة ومستقرة */}
            <div
              className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 pt-4 border-t border-gray-100 transition-all duration-300 origin-top ${showAdvancedFilters ? "opacity-100 scale-y-100 h-auto" : "opacity-0 scale-y-0 h-0 overflow-hidden pointer-events-none !pt-0 !border-t-0"}`}
            >
              {/* نوع الوثيقة */}
              <div className="relative group">
                <select
                  id="filterDocType"
                  className="block w-full p-4 pt-6 pb-2 text-sm text-right bg-white border border-gray-200 rounded-xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer text-[#263238] font-medium"
                  value={filters.documentType}
                  onChange={(e) =>
                    setFilters({ ...filters, documentType: e.target.value })
                  }
                >
                  <option value="">الكل</option>
                  {settings.docTypes.map((t) => (
                    <option key={t.id} value={t.name}>
                      {t.name}
                    </option>
                  ))}
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                  <ChevronDown size={16} />
                </div>
                <label
                  htmlFor="filterDocType"
                  className="absolute text-xs text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none peer-focus:text-[#546E7A]"
                >
                  نوع الوثيقة
                </label>
              </div>

              {/* تصنيف المشكلة */}
              <div className="relative group">
                <select
                  id="filterCategory"
                  className="block w-full p-4 pt-6 pb-2 text-sm text-right bg-white border border-gray-200 rounded-xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer text-[#263238] font-medium"
                  value={filters.category}
                  onChange={(e) =>
                    setFilters({ ...filters, category: e.target.value })
                  }
                >
                  <option value="">الكل</option>
                  {settings.categories.map((c) => (
                    <option key={c.id} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                  <ChevronDown size={16} />
                </div>
                <label
                  htmlFor="filterCategory"
                  className="absolute text-xs text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none peer-focus:text-[#546E7A]"
                >
                  تصنيف المشكلة
                </label>
              </div>

              {/* قناة المشكلة */}
              <div className="relative group">
                <select
                  id="filterChannel"
                  className="block w-full p-4 pt-6 pb-2 text-sm text-right bg-white border border-gray-200 rounded-xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer text-[#263238] font-medium"
                  value={filters.channel}
                  onChange={(e) =>
                    setFilters({ ...filters, channel: e.target.value })
                  }
                >
                  <option value="">الكل</option>
                  {settings.channels.map((ch) => (
                    <option key={ch.id} value={ch.name}>
                      {ch.name}
                    </option>
                  ))}
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                  <ChevronDown size={16} />
                </div>
                <label
                  htmlFor="filterChannel"
                  className="absolute text-xs text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none peer-focus:text-[#546E7A]"
                >
                  قناة المشكلة
                </label>
              </div>

              {/* آلية الحل */}
              <div className="relative group">
                <select
                  id="filterMechanism"
                  className="block w-full p-4 pt-6 pb-2 text-sm text-right bg-white border border-gray-200 rounded-xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer text-[#263238] font-medium"
                  value={filters.mechanism}
                  onChange={(e) =>
                    setFilters({ ...filters, mechanism: e.target.value })
                  }
                >
                  <option value="">الكل</option>
                  {settings.mechanisms.map((m) => (
                    <option key={m.id} value={m.name}>
                      {m.name}
                    </option>
                  ))}
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                  <ChevronDown size={16} />
                </div>
                <label
                  htmlFor="filterMechanism"
                  className="absolute text-xs text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none peer-focus:text-[#546E7A]"
                >
                  آلية الحل
                </label>
              </div>

              {/* حالة الاعتراض */}
              <div className="relative group">
                <select
                  id="filterObjection"
                  className="block w-full p-4 pt-6 pb-2 text-sm text-right bg-white border border-gray-200 rounded-xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer text-[#263238] font-medium"
                  value={filters.hasObjection}
                  onChange={(e) =>
                    setFilters({ ...filters, hasObjection: e.target.value })
                  }
                >
                  <option value="">الكل</option>
                  <option value="yes">بها اعتراض</option>
                  <option value="no">بدون اعتراض</option>
                </select>
                <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                  <ChevronDown size={16} />
                </div>
                <label
                  htmlFor="filterObjection"
                  className="absolute text-xs text-gray-400 duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none peer-focus:text-[#546E7A]"
                >
                  حالة الاعتراض
                </label>
              </div>

              {/* حقول التواريخ المتقدمة */}
              <div className="md:col-span-2 lg:col-span-5 grid grid-cols-2 md:grid-cols-4 gap-4 mt-2">
                <div className="relative">
                  <input
                    type="date"
                    id="reqStart"
                    className="block w-full p-4 pt-6 pb-2 text-sm text-center bg-gray-50 border border-gray-200 rounded-xl outline-none focus:bg-white focus:border-[#546E7A] transition-all text-gray-700 font-ibm peer"
                    value={filters.receivedStartDate}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        receivedStartDate: e.target.value,
                      })
                    }
                  />
                  <label
                    htmlFor="reqStart"
                    className="absolute text-[11px] text-[#546E7A] duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none"
                  >
                    تاريخ الورود من
                  </label>
                </div>

                <div className="relative">
                  <input
                    type="date"
                    id="reqEnd"
                    className="block w-full p-4 pt-6 pb-2 text-sm text-center bg-gray-50 border border-gray-200 rounded-xl outline-none focus:bg-white focus:border-[#546E7A] transition-all text-gray-700 font-ibm peer"
                    value={filters.receivedEndDate}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        receivedEndDate: e.target.value,
                      })
                    }
                  />
                  <label
                    htmlFor="reqEnd"
                    className="absolute text-[11px] text-[#546E7A] duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none"
                  >
                    تاريخ الورود إلى
                  </label>
                </div>

                <div className="relative">
                  <input
                    type="date"
                    id="entStart"
                    className="block w-full p-4 pt-6 pb-2 text-sm text-center bg-gray-50 border border-gray-200 rounded-xl outline-none focus:bg-white focus:border-[#546E7A] transition-all text-gray-700 font-ibm peer"
                    value={filters.entryStartDate}
                    onChange={(e) =>
                      setFilters({ ...filters, entryStartDate: e.target.value })
                    }
                  />
                  <label
                    htmlFor="entStart"
                    className="absolute text-[11px] text-[#546E7A] duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none"
                  >
                    تاريخ الدخول من
                  </label>
                </div>

                <div className="relative">
                  <input
                    type="date"
                    id="entEnd"
                    className="block w-full p-4 pt-6 pb-2 text-sm text-center bg-gray-50 border border-gray-200 rounded-xl outline-none focus:bg-white focus:border-[#546E7A] transition-all text-gray-700 font-ibm peer"
                    value={filters.entryEndDate}
                    onChange={(e) =>
                      setFilters({ ...filters, entryEndDate: e.target.value })
                    }
                  />
                  <label
                    htmlFor="entEnd"
                    className="absolute text-[11px] text-[#546E7A] duration-300 transform -translate-y-3 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none"
                  >
                    تاريخ الدخول إلى
                  </label>
                </div>
              </div>

              {/* زر مسح الفلاتر */}
              <div className="md:col-span-2 lg:col-span-5 flex justify-end pt-2">
                <button
                  onClick={() =>
                    setFilters({
                      documentType: "",
                      category: "",
                      channel: "",
                      mechanism: "",
                      hasObjection: "",
                      receivedStartDate: "",
                      receivedEndDate: "",
                      entryStartDate: "",
                      entryEndDate: "",
                    })
                  }
                  className="px-6 py-2 bg-red-50 hover:bg-red-100 text-red-500 rounded-xl font-bold transition text-xs flex items-center gap-1"
                >
                  <X size={14} />
                  <span>تفريغ كافة الفلاتر</span>
                </button>
              </div>
            </div>
          </div>

          {/* جدول البيانات الرئيسي */}
          <div className="overflow-x-auto">
            <table className="w-full text-right border-collapse">
              <thead>
                <tr className="bg-gray-50/50 text-gray-400 text-xs border-b border-gray-50">
                  <th className="px-4 py-5 font-medium">م</th>
                  <th className="px-4 py-5 font-medium">نوع الوثيقة</th>
                  <th className="px-4 py-5 font-medium">تصنيف المشكلة</th>
                  <th className="px-4 py-5 font-medium">قناة المشكلة</th>
                  <th className="px-4 py-5 font-medium">تاريخ الورود</th>
                  <th className="px-4 py-5 font-medium">تاريخ الدخول</th>
                  <th className="px-4 py-5 font-medium">المشكلة</th>
                  <th className="px-4 py-5 font-medium">حل المشكلة</th>
                  <th className="px-4 py-5 font-medium">الاعتراض على الحل</th>
                  <th className="px-4 py-5 font-medium">الحل بعد الاعتراض</th>
                  <th className="px-4 py-5 font-medium text-center">الآلية</th>
                  <th className="px-4 py-5 font-medium text-center">إجراءات</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-50">
                {currentItems.map((issue, index) => (
                  <tr
                    key={issue.id}
                    className="hover:bg-gray-50/60 transition-colors group text-sm"
                  >
                    <td className="px-4 py-4 font-ibm text-gray-400">
                      #{indexOfFirstItem + index + 1}
                    </td>
                    <td className="px-4 py-4 font-bold text-[#263238]">
                      {issue.documentType?.name}
                    </td>
                    <td className="px-4 py-4 text-[#263238]">
                      {issue.category?.name}
                    </td>
                    <td className="px-4 py-4 text-[#263238]">
                      {issue.channel?.name}
                    </td>
                    <td className="px-4 py-4 text-gray-500 font-ibm text-xs">
                      {issue.receivedDate
                        ? new Date(issue.receivedDate).toLocaleDateString(
                            "en-CA",
                          )
                        : "-"}
                    </td>
                    <td className="px-4 py-4 text-gray-500 font-ibm text-xs">
                      {issue.createdAt
                        ? new Date(issue.createdAt).toLocaleDateString("en-CA")
                        : "-"}
                    </td>
                    <td
                      className="px-4 py-4 max-w-[120px] truncate text-gray-600"
                      title={issue.problem}
                    >
                      {issue.problem}
                    </td>
                    <td
                      className="px-4 py-4 max-w-[120px] truncate text-gray-600"
                      title={issue.solution}
                    >
                      {issue.solution || "-"}
                    </td>
                    <td
                      className="px-4 py-4 max-w-[120px] truncate text-red-600 font-medium"
                      title={issue.objection}
                    >
                      {issue.objection || "لا يوجد"}
                    </td>
                    <td
                      className="px-4 py-4 max-w-[120px] truncate text-green-600"
                      title={issue.objectionSolution}
                    >
                      {issue.objectionSolution || "لا يوجد"}
                    </td>
                    <td className="px-4 py-4 text-center">
                      <span
                        className={`px-3 py-1 rounded-full text-[10px] font-bold ${issue.mechanism?.name === "تم الحل" ? "bg-green-50 text-green-600" : "bg-blue-50 text-blue-600"}`}
                      >
                        {issue.mechanism?.name || "قيد المراجعة"}
                      </span>
                    </td>
                    <td className="px-4 py-4 flex justify-center gap-1">
                      <button
                        onClick={() => handleView(issue)}
                        className="p-2 text-gray-400 hover:text-green-500 hover:bg-green-50 rounded-lg transition"
                      >
                        <Eye size={16} />
                      </button>
                      <button
                        onClick={() => handleEdit(issue)}
                        className="p-2 text-gray-400 hover:text-blue-500 hover:bg-blue-50 rounded-lg transition"
                      >
                        <Edit3 size={16} />
                      </button>
                      <button
                        onClick={() => handleDelete(issue.id)}
                        className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition"
                      >
                        <Trash2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* شريط تفاصيل العرض عند الضغط على العين */}
          {isViewOpen && selectedIssue && (
            <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
              <div
                className="absolute inset-0 bg-[#263238]/40 backdrop-blur-sm"
                onClick={() => setIsViewOpen(false)}
              ></div>
              <div className="relative bg-white w-full max-w-4xl rounded-[2.5rem] shadow-2xl overflow-hidden p-8 animate-in zoom-in duration-200">
                <div className="flex justify-between items-center mb-6">
                  <div className="flex items-center gap-3">
                    <h3 className="text-xl font-bold text-[#263238]">
                      تفاصيل المشكلة والتواريخ
                    </h3>
                    <span
                      className={`px-3 py-1 rounded-full text-sm font-bold ${selectedIssue.mechanism?.name === "تم الحل" ? "bg-green-100 text-green-600" : "bg-yellow-100 text-yellow-600"}`}
                    >
                      {selectedIssue.mechanism?.name || "قيد المراجعة"}
                    </span>
                  </div>
                  <button
                    type="button"
                    onClick={() => setIsModalOpen && setIsViewOpen(false)}
                    className="p-2 hover:bg-gray-100 rounded-full text-gray-400"
                  >
                    <X size={24} />
                  </button>
                </div>

                <div className="space-y-4">
                  <div className="grid grid-cols-2 md:grid-cols-5 gap-2">
                    <div className="relative col-span-1">
                      <input
                        value={selectedIssue.documentType?.name || ""}
                        readOnly
                        className="block w-full p-2 pt-5 text-right bg-gray-50 border border-gray-100 rounded-xl text-xs font-bold"
                      />
                      <label className="absolute text-[10px] text-gray-400 top-1 right-2">
                        نوع الوثيقة
                      </label>
                    </div>
                    <div className="relative col-span-1">
                      <input
                        value={selectedIssue.category?.name || ""}
                        readOnly
                        className="block w-full p-2 pt-5 text-right bg-gray-50 border border-gray-100 rounded-xl text-xs"
                      />
                      <label className="absolute text-[10px] text-gray-400 top-1 right-2">
                        التصنيف
                      </label>
                    </div>
                    <div className="relative col-span-1">
                      <input
                        value={selectedIssue.channel?.name || ""}
                        readOnly
                        className="block w-full p-2 pt-5 text-right bg-gray-50 border border-gray-100 rounded-xl text-xs"
                      />
                      <label className="absolute text-[10px] text-gray-400 top-1 right-2">
                        القناة
                      </label>
                    </div>
                    <div className="relative col-span-1">
                      <input
                        value={
                          selectedIssue.receivedDate
                            ? selectedIssue.receivedDate.split("T")[0]
                            : "---"
                        }
                        readOnly
                        className="block w-full p-2 pt-5 text-center bg-gray-50 border border-gray-100 rounded-xl text-xs text-[#546E7A]"
                      />
                      <label className="absolute text-[10px] text-gray-400 top-1 right-2">
                        تاريخ الورود
                      </label>
                    </div>
                    <div className="relative col-span-1">
                      <input
                        value={
                          selectedIssue.createdAt
                            ? selectedIssue.createdAt.split("T")[0]
                            : "---"
                        }
                        readOnly
                        className="block w-full p-2 pt-5 text-center bg-gray-50 border border-gray-100 rounded-xl text-xs text-[#546E7A]"
                      />
                      <label className="absolute text-[10px] text-gray-400 top-1 right-2">
                        تاريخ الدخول
                      </label>
                    </div>
                  </div>

                  <div className="relative">
                    <textarea
                      value={selectedIssue.problem || ""}
                      readOnly
                      rows={2}
                      className="block w-full p-3 pt-5 text-right bg-gray-50 border border-gray-100 rounded-xl resize-none text-sm"
                    />
                    <label className="absolute text-xs text-gray-400 top-1 right-3">
                      وصف المشكلة
                    </label>
                  </div>

                  <div className="relative">
                    <textarea
                      value={selectedIssue.solution || ""}
                      readOnly
                      rows={2}
                      className="block w-full p-3 pt-5 text-right bg-gray-50 border border-gray-100 rounded-xl resize-none text-sm"
                    />
                    <label className="absolute text-xs text-gray-400 top-1 right-3">
                      حل المشكلة الرئيسي
                    </label>
                  </div>

                  <div className="grid grid-cols-2 gap-4">
                    <div className="relative">
                      <textarea
                        value={
                          selectedIssue.objection || "لا يوجد اعتراض حتى الآن"
                        }
                        readOnly
                        rows={2}
                        className="block w-full p-3 pt-5 text-right bg-red-50/40 border border-red-100 rounded-xl resize-none text-sm text-red-700"
                      />
                      <label className="absolute text-xs text-red-500 top-1 right-3">
                           إعاده فتح المشكلة (و السبب أن وجد)
                      </label>
                    </div>
                    <div className="relative">
                      <textarea
                        value={
                          selectedIssue.objectionSolution ||
                          "لم يتم توفير حل بعد الاعتراض"
                        }
                        readOnly
                        rows={2}
                        className="block w-full p-3 pt-5 text-right bg-green-50/40 border border-green-100 rounded-xl resize-none text-sm text-green-700"
                      />
                      <label className="absolute text-xs text-green-600 top-1 right-3">
                        حل المشكلة  
                      </label>
                    </div>
                  </div>

                  <div className="relative">
                    <textarea
                      value={selectedIssue.notes || ""}
                      readOnly
                      rows={2}
                      className="block w-full p-3 pt-5 text-right bg-gray-50 border border-gray-100 rounded-xl resize-none text-sm"
                    />
                    <label className="absolute text-xs text-gray-400 top-1 right-3">
                      الملاحظات
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* الترقيم التلقائي للملف والصفحات */}
          <div className="flex items-center justify-between px-8 py-4 bg-gray-50/30 border-t border-gray-50">
            <div className="text-xs text-gray-500 font-ibm">
              عرض{" "}
              <span className="font-bold text-[#546E7A]">
                {indexOfFirstItem + 1}
              </span>{" "}
              إلى{" "}
              <span className="font-bold text-[#546E7A]">
                {Math.min(indexOfLastItem, sortedIssues.length)}
              </span>{" "}
              من أصل{" "}
              <span className="font-bold text-[#546E7A]">
                {sortedIssues.length}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                disabled={currentPage === 1}
                className={`p-2 rounded-xl border transition-all ${currentPage === 1 ? "text-gray-200 border-gray-100" : "bg-white text-[#546E7A] border-gray-200 hover:border-[#546E7A]"}`}
              >
                <ChevronRight size={18} />
              </button>
              <div className="flex gap-1">
                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i + 1}
                    onClick={() => setCurrentPage(i + 1)}
                    className={`w-8 h-8 rounded-lg text-xs font-bold transition-all ${currentPage === i + 1 ? "bg-[#546E7A] text-white" : "bg-white text-gray-400 hover:bg-gray-50"}`}
                  >
                    {i + 1}
                  </button>
                ))}
              </div>
              <button
                onClick={() =>
                  setCurrentPage((p) => Math.min(totalPages, p + 1))
                }
                disabled={currentPage === totalPages}
                className={`p-2 rounded-xl border transition-all ${currentPage === totalPages ? "text-gray-200 border-gray-100" : "bg-white text-[#546E7A] border-gray-200 hover:border-[#546E7A]"}`}
              >
                <ChevronLeft size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* Modal الإضافة والتعديل الأساسي */}
        {isModalOpen && (
          <div className="fixed inset-0 z-[150] flex items-center justify-center p-4">
            <div
              className="absolute inset-0 bg-[#263238]/40 backdrop-blur-sm"
              onClick={() => setIsModalOpen(false)}
            ></div>
            <div className="relative bg-white w-full max-w-4xl rounded-[2.5rem] shadow-2xl p-8 animate-in zoom-in duration-200 max-h-[90vh] overflow-y-auto">
              <div className="flex justify-between items-center mb-8">
                <h3 className="text-xl font-bold text-[#263238]">
                  {newIssue.id
                    ? "تعديل بيانات المشكلة والاعتراض"
                    : "إضافة مشكلة جديدة"}
                </h3>
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="p-2 hover:bg-gray-100 rounded-full text-gray-400"
                >
                  <X size={24} />
                </button>
              </div>

              <form onSubmit={handleAddIssue} className="space-y-5">
                <div className="grid grid-cols-4 gap-4">
                  <div className="relative group">
                    <select
                      id="docType"
                      required
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer"
                      value={newIssue.documentTypeId}
                      onChange={(e) =>
                        setNewIssue({
                          ...newIssue,
                          documentTypeId: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled hidden></option>
                      {settings.docTypes.map((t) => (
                        <option key={t.id} value={t.id}>
                          {t.name}
                        </option>
                      ))}
                    </select>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                    <label
                      htmlFor="docType"
                      className={`absolute text-sm text-gray-500 duration-300 transform z-10 origin-[right] right-4 pointer-events-none ${newIssue.documentTypeId ? "-translate-y-4 scale-75 top-4" : "translate-y-0 scale-100 top-4"} peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A]`}
                    >
                      اختر نوع الوثيقة...
                    </label>
                  </div>

                  <div className="relative group">
                    <select
                      id="category"
                      required
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer"
                      value={newIssue.categoryId}
                      onChange={(e) =>
                        setNewIssue({ ...newIssue, categoryId: e.target.value })
                      }
                    >
                      <option value="" disabled hidden></option>
                      {settings.categories.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </select>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                    <label
                      htmlFor="category"
                      className={`absolute text-sm text-gray-500 duration-300 transform z-10 origin-[right] right-4 pointer-events-none ${newIssue.categoryId ? "-translate-y-4 scale-75 top-4" : "translate-y-0 scale-100 top-4"} peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A]`}
                    >
                      اختر التصنيف...
                    </label>
                  </div>

                  <div className="relative group">
                    <select
                      id="channel"
                      required
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer"
                      value={newIssue.channelId}
                      onChange={(e) =>
                        setNewIssue({ ...newIssue, channelId: e.target.value })
                      }
                    >
                      <option value="" disabled hidden></option>
                      {settings.channels.map((ch) => (
                        <option key={ch.id} value={ch.id}>
                          {ch.name}
                        </option>
                      ))}
                    </select>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                    <label
                      htmlFor="channel"
                      className={`absolute text-sm text-gray-500 duration-300 transform z-10 origin-[right] right-4 pointer-events-none ${newIssue.channelId ? "-translate-y-4 scale-75 top-4" : "translate-y-0 scale-100 top-4"} peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A]`}
                    >
                      اختر القناة...
                    </label>
                  </div>

                  <div className="relative group">
                    <input
                      type="date"
                      id="receivedDate"
                      dir="ltr"
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer text-[#546E7A]"
                      value={newIssue.receivedDate}
                      onChange={(e) =>
                        setNewIssue({
                          ...newIssue,
                          receivedDate: e.target.value,
                        })
                      }
                    />
                    <label
                      htmlFor="receivedDate"
                      className="absolute text-xs text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-4 pointer-events-none"
                    >
                      تاريخ ورود المشكلة (إن وجد)
                    </label>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="relative">
                    <textarea
                      id="problem"
                      rows="2"
                      placeholder=" "
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer"
                      value={newIssue.problem}
                      onChange={(e) =>
                        setNewIssue({ ...newIssue, problem: e.target.value })
                      }
                      required
                    />
                    <label
                      htmlFor="problem"
                      className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-4 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A] pointer-events-none"
                    >
                      وصف المشكلة
                    </label>
                  </div>

                  <div className="relative w-full">
                    <textarea
                      id="solution"
                      rows="2"
                      placeholder=" "
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer"
                      value={newIssue.solution}
                      onChange={(e) =>
                        setNewIssue({ ...newIssue, solution: e.target.value })
                      }
                      required
                    />
                    <label
                      htmlFor="solution"
                      className="absolute text-sm text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-4 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A] pointer-events-none"
                    >
                      حل المشكلة
                    </label>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="relative">
                    <textarea
                      id="objection"
                      rows="2"
                      placeholder=" "
                      className="block w-full p-4 pt-6 text-right bg-red-50/20 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer"
                      value={newIssue.objection}
                      onChange={(e) =>
                        setNewIssue({ ...newIssue, objection: e.target.value })
                      }
                    />
                    <label
                      htmlFor="objection"
                      className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-4 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A] pointer-events-none"
                    >
                       إعاده فتح المشكلة (السبب أن وجد )
                    </label>
                  </div>

                  <div className="relative w-full">
                    <textarea
                      id="objectionSolution"
                      rows="2"
                      placeholder=" "
                      className="block w-full p-4 pt-6 text-right bg-green-50/20 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer"
                      value={newIssue.objectionSolution}
                      onChange={(e) =>
                        setNewIssue({
                          ...newIssue,
                          objectionSolution: e.target.value,
                        })
                      }
                    />
                    <label
                      htmlFor="objectionSolution"
                      className="absolute text-sm text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-4 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A] pointer-events-none"
                    >
                      حل المشكلة  
                    </label>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="relative group">
                    <select
                      id="mechanism"
                      required
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer appearance-none cursor-pointer"
                      value={newIssue.mechanismId}
                      onChange={(e) =>
                        setNewIssue({
                          ...newIssue,
                          mechanismId: e.target.value,
                        })
                      }
                    >
                      <option value="" disabled hidden></option>
                      {settings.mechanisms.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </select>
                    <div className="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400 peer-focus:text-[#546E7A]">
                      <ChevronDown size={18} />
                    </div>
                    <label
                      htmlFor="mechanism"
                      className={`absolute text-sm text-gray-500 duration-300 transform z-10 origin-[right] right-4 pointer-events-none ${newIssue.mechanismId ? "-translate-y-4 scale-75 top-4" : "translate-y-0 scale-100 top-4"} peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A]`}
                    >
                      اختر آلية الحل...
                    </label>
                  </div>

                  <div className="relative w-full">
                    <input
                      type="text"
                      id="notes"
                      placeholder=" "
                      className="block w-full p-4 pt-6 text-right bg-gray-50 border border-gray-100 rounded-2xl outline-none focus:border-[#546E7A] transition-all peer"
                      value={newIssue.notes}
                      onChange={(e) =>
                        setNewIssue({ ...newIssue, notes: e.target.value })
                      }
                    />
                    <label
                      htmlFor="notes"
                      className="absolute text-sm text-gray-400 duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[right] right-4 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4 peer-focus:text-[#546E7A] pointer-events-none"
                    >
                      الملاحظات (اختياري)
                    </label>
                  </div>
                </div>

                <div className="flex gap-4 pt-4">
                  <button
                    type="submit"
                    className="flex-1 bg-[#546E7A] text-white font-bold py-4 rounded-2xl hover:bg-[#263238] transition shadow-lg active:scale-[0.98]"
                  >
                    حفظ البيانات
                  </button>
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="flex-1 bg-gray-100 text-gray-500 font-bold py-4 rounded-2xl"
                  >
                    إلغاء
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupportdSec1;